// SolutionLayout.jsx - Product-focused layout for solution pages (Tier 3)
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function SolutionLayout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      {/* Header with CTA */}
      <header className="border-b border-gray-100 sticky top-0 bg-white/95 backdrop-blur-sm z-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="inline-flex items-center gap-2 group">
              <div className="w-8 h-8 bg-[#172A3A] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">P</span>
              </div>
              <span className="text-[#172A3A] font-semibold text-lg group-hover:text-[#FFB800] transition-colors">
                Pro IRP
              </span>
            </Link>
            <div className="flex items-center gap-4">
              <Link
                to="/pricing"
                className="text-sm text-gray-600 hover:text-[#172A3A] hidden sm:inline"
              >
                Pricing
              </Link>
              <Link
                to="/signup"
                className="inline-flex items-center gap-2 bg-[#FFB800] text-[#172A3A] font-semibold px-4 py-2 rounded-lg hover:bg-[#e5a600] transition-colors text-sm"
              >
                Get Started
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {children}
      </main>

      {/* Footer */}
      <footer className="bg-[#172A3A] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
          <div className="grid md:grid-cols-4 gap-8">
            <div className="md:col-span-2">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                  <span className="text-[#172A3A] font-bold text-sm">P</span>
                </div>
                <span className="font-semibold text-lg">Pro IRP</span>
              </div>
              <p className="text-gray-400 text-sm max-w-md">
                The Medicare client retention platform built by agents, for agents.
                Stop losing clients. Start building lasting relationships.
              </p>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Product</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/pricing" className="hover:text-white">Pricing</Link></li>
                <li><Link to="/signup" className="hover:text-white">Get Started</Link></li>
                <li><Link to="/login" className="hover:text-white">Sign In</Link></li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-4">Resources</h4>
              <ul className="space-y-2 text-sm text-gray-400">
                <li><Link to="/learn" className="hover:text-white">Learn</Link></li>
                <li><Link to="/blog" className="hover:text-white">Blog</Link></li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} Pro IRP. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm text-gray-400">
              <Link to="/privacy" className="hover:text-white">Privacy</Link>
              <Link to="/terms" className="hover:text-white">Terms</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
